var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c("b-table", {
                    attrs: {
                      fields: _vm.tablaAcreditacionesApeiron,
                      items: _vm.acreditaciones,
                      "thead-class": "custom-header",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(accion)",
                        fn: function ({ item }) {
                          return [
                            _vm.getComprobante(item)
                              ? _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.right",
                                        modifiers: { hover: true, right: true },
                                      },
                                    ],
                                    attrs: {
                                      variant: "outline-secondary",
                                      title: _vm.$t(
                                        "apeironGwApp.historicoAcreditaciones.headers.comprobante"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getComprobante(item),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("b-icon-file-earmark-pdf-fill", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("documentos.noEncontrado")
                                    ),
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "bandejaAcreditaciones.cumpleAcreditacion"
                            ),
                          },
                        },
                        [
                          _c("b-form-radio-group", {
                            attrs: {
                              id: "radio-cumpleAcreditacion-1",
                              "button-variant": "outline-danger",
                              name: "cumpleAcreditacion",
                              options: _vm.opcionesBoleanas,
                              disabled: !_vm.rolOperador,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.guardarValidacionAcreditacion()
                              },
                            },
                            model: {
                              value: _vm.cumpleAcreditacion,
                              callback: function ($$v) {
                                _vm.cumpleAcreditacion = $$v
                              },
                              expression: "cumpleAcreditacion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }